import React, { memo } from "react";
// @ts-ignore
import bgTop from "./../Assets/Images/bg-top.svg";
// @ts-ignore
import bgBottom from "./../Assets/Images/bg-bottom.png";

const CARD_KEYS = ["f1", "f2", "f3", "f4", "f5", "f6", "f7", "f8"];

const CardSkeleton = () => (
  <div className="col-12 col-sm-6 col-md-4 my-3 col-xl-3">
    <div className="card border-0 shadow br-10px h-100">
      <span
        className="placeholder d-block w-100"
        style={{ aspectRatio: "16 / 9", borderRadius: 10 }}
        aria-hidden="true"
      />
      <div className="p-3">
        <span
          className="placeholder d-block col-9 mb-2"
          style={{ height: 16, borderRadius: 4 }}
          aria-hidden="true"
        />
        <span
          className="placeholder d-block col-6"
          style={{ height: 12, borderRadius: 4 }}
          aria-hidden="true"
        />
      </div>
    </div>
  </div>
);

const FavouriteSkeleton = () => {
  return (
    <div className="position-relative placeholder-glow" role="status" aria-label="Loading">
      <img className="bg-top" src={bgTop} alt="bg top" />
      <div className="container-xxl my-4">
        <p className="fw-bold mt-5 font-21">Your Favourite Videos</p>
        <div className="row">
          {CARD_KEYS.map((key) => (
            <CardSkeleton key={key} />
          ))}
        </div>
      </div>
      <img className="bg-bottom" src={bgBottom} alt="bg bottom" />
      <div style={{ height: 150 }}></div>
      <span className="visually-hidden">Loading…</span>
    </div>
  );
};

export default memo(FavouriteSkeleton);
